import type { IconProps } from '../../types';

export const GlobeBlobIcon = ({
  className,
  color = 'currentColor',
  size = 24,
  ...props
}: IconProps) => {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M13.5727 9.35268C13.5727 10.2403 12.8564 10.9566 11.9689 10.9566C11.0813 10.9566 10.365 10.2403 10.365 9.35268C10.365 8.46505 11.0813 7.74872 11.9689 7.74872C12.8564 7.74872 13.5727 8.46505 13.5727 9.35268Z'
        fill={color}
      />
      <path
        d='M13.6973 8.17695C13.0822 7.73313 12.8331 7.02459 13.1367 6.60413C13.4404 6.17589 14.1956 6.19146 14.8106 6.63527C15.4257 7.07909 15.6748 7.78764 15.3712 8.21588C15.0676 8.64412 14.3124 8.62855 13.6973 8.18474'
        fill={color}
      />
      <path
        d='M15.5425 6.87665C15.9551 7.15695 16.4145 7.21146 16.5624 6.99344C16.7103 6.77543 16.5001 6.36276 16.0797 6.08245C15.6671 5.80215 15.2077 5.74764 15.0598 5.96566C14.9119 6.18367 15.1221 6.58856 15.5425 6.87665Z'
        fill={color}
      />
      <path
        d='M11.8677 6.18368C12.4905 6.19147 12.9966 5.93452 13.0044 5.6075C13.0044 5.28048 12.5061 5.00796 11.8832 5.00017C11.2604 4.99239 10.7543 5.24933 10.7465 5.57635C10.7465 5.90338 11.2448 6.17589 11.8677 6.18368Z'
        fill={color}
      />
      <path
        d='M8.55871 8.22367C8.86235 8.65191 9.61756 8.63634 10.2326 8.19252C10.8477 7.74871 11.0969 7.04016 10.7932 6.61191C10.4818 6.18367 9.73435 6.19924 9.11928 6.64306C8.50421 7.08687 8.25506 7.79542 8.55871 8.21588V8.22367Z'
        fill={color}
      />
      <path
        d='M8.41856 6.91559C8.8312 6.63528 9.0492 6.22261 8.90128 6.0046C8.75335 5.78658 8.29399 5.84109 7.88135 6.12139C7.46871 6.4017 7.25071 6.81437 7.39864 7.03238C7.54656 7.2504 8.00592 7.19589 8.41856 6.91559Z'
        fill={color}
      />
      <path
        d='M10.9489 11.9766C10.9489 12.8643 10.2326 13.5806 9.34507 13.5806C8.4575 13.5806 7.74121 12.8643 7.74121 11.9766C7.74121 11.089 8.4575 10.3727 9.34507 10.3727C10.2326 10.3727 10.9489 11.089 10.9489 11.9766Z'
        fill={color}
      />
      <path
        d='M6.63565 14.8108C6.19187 14.1957 6.1763 13.4482 6.60451 13.1368C7.03272 12.8253 7.73343 13.0823 8.185 13.6974C8.62879 14.3125 8.64436 15.06 8.21615 15.3714C7.78793 15.6751 7.08722 15.4259 6.64344 14.8108'
        fill={color}
      />
      <path
        d='M5.97386 15.0522C5.75586 15.2001 5.81036 15.6595 6.09065 16.0722C6.37093 16.4849 6.78358 16.7029 7.00157 16.5549C7.21957 16.407 7.16507 15.9476 6.88479 15.535C6.6045 15.1223 6.19186 14.9043 5.97386 15.0522Z'
        fill={color}
      />
      <path
        d='M6.18408 11.8676C6.17629 11.2447 5.90379 10.7464 5.5768 10.7464C5.2498 10.7464 4.98508 11.2603 5.00065 11.8832C5.00844 12.5061 5.28094 13.0044 5.60794 13.0044C5.93494 13.0044 6.19187 12.4905 6.18408 11.8676Z'
        fill={color}
      />
      <path
        d='M6.6201 10.7931C7.04831 11.0968 7.74903 10.8476 8.2006 10.2325C8.64438 9.61742 8.65995 8.86994 8.23174 8.5585C7.80352 8.25483 7.09503 8.50399 6.65903 9.1191C6.21524 9.73422 6.19967 10.4817 6.62788 10.7931H6.6201Z'
        fill={color}
      />
      <path
        d='M6.92373 8.41832C7.20401 8.00565 7.25851 7.54626 7.04051 7.39832C6.82251 7.25039 6.40987 7.46061 6.12959 7.88107C5.8493 8.30153 5.7948 8.75313 6.0128 8.90107C6.2308 9.04901 6.63566 8.83878 6.92373 8.41832Z'
        fill={color}
      />
      <path
        d='M13.1601 15.7841C13.7829 15.1612 13.7829 14.1412 13.1601 13.5183C12.5372 12.8954 11.5173 12.8954 10.8944 13.5183C10.2716 14.1412 10.2716 15.1612 10.8944 15.7841C11.5173 16.407 12.5294 16.407 13.1601 15.7841Z'
        fill={color}
      />
      <path
        d='M10.3027 15.823C10.9178 16.2669 11.1669 16.9754 10.8633 17.4036C10.5596 17.8319 9.80442 17.8163 9.18935 17.3725C8.57428 16.9287 8.32513 16.2201 8.62877 15.7919C8.93242 15.3637 9.68763 15.3792 10.3027 15.823Z'
        fill={color}
      />
      <path
        d='M8.47309 17.1156C8.06045 16.8353 7.60109 16.7807 7.45316 16.9988C7.30524 17.2168 7.51545 17.6294 7.93588 17.9098C8.34852 18.1901 8.80787 18.2446 8.9558 18.0265C9.10373 17.8085 8.89352 17.3959 8.47309 17.1156Z'
        fill={color}
      />
      <path
        d='M12.1323 17.8163C11.5095 17.8085 11.0034 18.0655 10.9956 18.3925C10.9956 18.7195 11.4939 18.992 12.1168 18.9998C12.7396 19.0076 13.2457 18.7507 13.2535 18.4236C13.2535 18.0966 12.7552 17.8241 12.1323 17.8163Z'
        fill={color}
      />
      <path
        d='M15.4413 15.7763C15.1376 15.3481 14.3824 15.3637 13.7673 15.8075C13.1523 16.2513 12.9031 16.9598 13.2068 17.3881C13.5104 17.8163 14.2656 17.8007 14.8807 17.3569C15.4958 16.9131 15.7449 16.2046 15.4413 15.7841V15.7763Z'
        fill={color}
      />
      <path
        d='M15.5736 17.0766C15.161 17.3647 14.943 17.7696 15.0909 17.9876C15.2388 18.2056 15.6982 18.1511 16.1108 17.8708C16.5235 17.5905 16.7415 17.1779 16.5936 16.9598C16.4456 16.7418 15.9863 16.7963 15.5736 17.0766Z'
        fill={color}
      />
      <path
        d='M16.251 12.0234C16.251 12.911 15.5347 13.6273 14.6471 13.6273C13.7596 13.6273 13.0433 12.911 13.0433 12.0234C13.0433 11.1357 13.7596 10.4194 14.6471 10.4194C15.5347 10.4194 16.251 11.1357 16.251 12.0234Z'
        fill={color}
      />
      <path
        d='M17.3643 9.18918C16.9206 8.57406 16.2121 8.32491 15.7916 8.62857C15.3634 8.93223 15.379 9.6875 15.8228 10.3026C16.2666 10.9177 16.9751 11.1669 17.4033 10.8632C17.8315 10.5518 17.8159 9.80429 17.3721 9.18918H17.3643Z'
        fill={color}
      />
      <path
        d='M18.0339 8.93999C18.2519 8.79205 18.1974 8.33266 17.9171 7.91999C17.6368 7.50732 17.2242 7.28931 17.0062 7.43724C16.7882 7.58518 16.8427 8.04457 17.123 8.45724C17.4033 8.86991 17.8159 9.08793 18.0339 8.93999Z'
        fill={color}
      />
      <path
        d='M18.3921 10.9956C18.0651 10.9956 17.8081 11.5095 17.8159 12.1324C17.8237 12.7553 18.0962 13.2536 18.4232 13.2536C18.7502 13.2536 19.0149 12.7397 18.9993 12.1168C18.9916 11.4939 18.7191 10.9956 18.3921 10.9956Z'
        fill={color}
      />
      <path
        d='M15.7761 15.4415C16.2043 15.7452 16.9128 15.496 17.3488 14.8809C17.7926 14.2658 17.8081 13.5183 17.3799 13.2069C16.9517 12.9032 16.251 13.1524 15.7994 13.7675C15.3556 14.3826 15.3401 15.1301 15.7683 15.4415H15.7761Z'
        fill={color}
      />
      <path
        d='M17.0763 15.5739C16.796 15.9866 16.7415 16.4459 16.9595 16.5939C17.1775 16.7418 17.5901 16.5316 17.8704 16.1111C18.1507 15.6985 18.2052 15.2391 17.9872 15.0911C17.7692 14.9432 17.3565 15.1534 17.0763 15.5739Z'
        fill={color}
      />
    </svg>
  );
};

export default GlobeBlobIcon;
